import React from 'react';
import btn_white from "../../assets/images/btn_white.png";

const CashBlock = ({openLeaderboard}) => {
    const cash = {
        amount: 300,
        perDay: 3
    }

    const editCashStr = (amount) => {
        return amount <= 9 && amount > 0 ? "0" + amount.toString() : amount
    }

    return (
        <div
            className="flex flex-col xl:flex-row bg-[rgba(85,_153,_255,_0.8)] place-items-center justify-between rounded-[15px] mt-10 mx-5 xl:mx-20 py-2 px-5 xl:px-10">
            <div className="flex flex-col xl:flex-row text-[30px] font-gilroy font-bold normal-case">
                <div className="flex place-items-center xl:place-items-start flex-col xl:flex-row mr-0 border-r-[0px] xl:border-r-[3px] xl:border-r-white xl:pr-[30px] xl:mr-[30px]">
                    <p>Speed Cash per day</p>
                    <span className="ml-0 xl:ml-5">{editCashStr(cash.perDay)}</span>
                </div>
                <div className="flex place-items-center xl:place-items-start flex-col xl:flex-row">
                    <p>Your Speed Cash</p>
                    <span className="ml-0 xl:ml-5">{editCashStr(cash.amount)}</span>
                </div>
            </div>
            <div className="relative place-self-center w-max cursor-pointer hvr-grow-rotate" onClick={() => openLeaderboard(true)}>
                <img className="w-[300px] xl:w-[380px]" src={btn_white} width={380} alt="white_btn"/>
                <p className="absolute text-black text-[26px] xl:text-[30px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pl-14 pt-3">Leaderboard</p>
            </div>
        </div>
    );
};

export default CashBlock;